import React from 'react';
import { useTypedSelector } from 'combineReducers';
import { useLocation } from 'react-router-dom';

export const EstimateOneRedirect: React.FC = () => {
  const { userInfo } = useTypedSelector(state => state.userInfo);
  const orgId = userInfo?.primaryOrganizationId;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const companyName = searchParams.get('name');
  const callbackUrl = searchParams.get('redirectUrl');

  React.useEffect(() => {
    if (orgId) {
      window.location.replace(
        `/organizations/${orgId}/partners/estimateone?redirectUrl=${callbackUrl}?name=${companyName}`
      );
    }
  }, [orgId, callbackUrl, companyName]);

  return null;
};
